<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>系统管理</el-breadcrumb-item>
			<el-breadcrumb-item>日志管理</el-breadcrumb-item>
		</el-breadcrumb>

		<div class="form-bar">
			<el-form :inline="true">
				<el-form-item label="用户姓名">
					<el-input placeholder="用户姓名" v-model="realName" maxlength="20"></el-input>
				</el-form-item>
				<el-form-item label="请求内容">
					<el-input placeholder="请输入批次关键字" v-model="body" maxlength="150"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="info" @click="getData">搜索</el-button>
				</el-form-item>
			</el-form>
		</div>

		<el-table border v-loading="loading" :data="tableData" size="medium">
			<el-table-column type="index" label="序号" width="60"> </el-table-column>
			<el-table-column property="username" label="账号" width="150"></el-table-column>
			<el-table-column property="realName" label="用户姓名" width="150"></el-table-column>
			<el-table-column property="method" label="方法" width="60"></el-table-column>
			<el-table-column property="uri" label="请求地址" width="350"></el-table-column>
			<el-table-column property="body" label="请求内容"></el-table-column>
			<el-table-column label="时间" width="180">
				<template slot-scope="scope">
					<span v-text="getTime(scope.row.access_time)"></span>
				</template>
			</el-table-column>
		</el-table>

		<!--分页-->
		<el-pagination layout="sizes, prev, pager, next, total" :page-count="pageCount" :page-sizes="[10, 50, 100, 200]" :size="pageSize" @current-change="currentChange" @size-change="sizeChange"> </el-pagination>
	</div>
</template>

<script>
	import { accessLogRequest } from '@/network/requests/accessLog'
	import moment from 'moment'
	import { $in, like } from '@/network/util/QueryBuilder'
	export default {
		data() {
			this.documentHeight = document.body.clientHeight
			return {
				tableData: [],
				pageIndex: 1,
				pageSize: 10,
				pageCount: 1,
				realName: '',
				body: '',
				loading: false,
			}
		},
		methods: {
			/**
			 *
			 */
			currentChange(page) {
				this.pageIndex = page
				this.getData()
			},
			/**
			 * 切换页码。
			 */
			sizeChange(size) {
				this.pageSize = size
				this.pageIndex = 1
				this.getData()
			},
			/**
			 *
			 */
			getFilter() {
				var filter = {}
				var propertyCount = 0
				if (this.realName) {
					filter.realName = like(this.realName)
					propertyCount++
				}

				if (this.body) {
					filter.body = like(this.body)
					propertyCount++
				}

				if (propertyCount) {
					return filter
				}

				return undefined
			},
			/**
			 * 加载日志数据。
			 */
			getData() {
				this.loading = true
				accessLogRequest
					.queryPage({
						page: this.pageIndex,
						pagesize: this.pageSize,
						filter: this.getFilter(),
						sort: undefined,
					})
					.then(res => {
						this.tableData = res.data._embedded
						this.pageCount = res.data._total_pages
						console.log('access_log', res)
					})
					.finally(() => {
						this.loading = false
					})
			},
			getTime(time) {
				return moment(time.$date).format('YYYY-MM-DD HH:mm:ss')
			},
		},
		created() {
			this.getData()
		},
	}
</script>

<style scoped>
	.nav-box {
		width: 180px;
		height: 120px;
		margin: 0 auto;
		padding-top: 40px;
		border: 1px #eee solid;
		background-color: #fafafa;
		text-align: center;
	}

	.nav-box i {
		font-size: 48px;
		margin-bottom: 20px;
	}
</style>
